export var merge = function(left, right) {
  if (!left) {
    return right;
  }

  for (var attrname in right) {
    if (left[attrname] === undefined) {
      left[attrname] = right[attrname];
    }
  }

  return left;
};
